import type { SxProps, Theme } from '@mui/material/styles';

/** Display face for public marketing pages; body copy stays on DM Sans. */
export const MARKETING_DISPLAY_FONT =
  '"Plus Jakarta Sans", "DM Sans", system-ui, -apple-system, "Segoe UI", sans-serif';

export type MarketingHeadingLevel = 'display' | 'h1' | 'h2' | 'h3';

const baseHeading = {
  fontFamily: MARKETING_DISPLAY_FONT,
  // Avoid negative tracking — it doubles edge glyphs in Chrome/Windows (DEEP-BUG-001).
  letterSpacing: '0em',
  color: 'text.primary',
} as const;

export const marketingHeadingStyles: Record<MarketingHeadingLevel, SxProps<Theme>> = {
  display: {
    ...baseHeading,
    fontWeight: 800,
    lineHeight: 1.1,
    fontSize: { xs: '2.125rem', sm: '2.5rem', md: '3rem' },
  },
  h1: {
    ...baseHeading,
    fontWeight: 800,
    lineHeight: 1.15,
    fontSize: { xs: '1.875rem', sm: '2.125rem', md: '2.375rem' },
  },
  h2: {
    ...baseHeading,
    fontWeight: 700,
    lineHeight: 1.2,
    fontSize: { xs: '1.5rem', sm: '1.625rem', md: '1.875rem' },
  },
  h3: {
    ...baseHeading,
    fontWeight: 700,
    lineHeight: 1.25,
    fontSize: { xs: '1.125rem', sm: '1.25rem', md: '1.375rem' },
  },
};

export const marketingSubheadingSx: SxProps<Theme> = {
  fontFamily: MARKETING_DISPLAY_FONT,
  fontWeight: 600,
  letterSpacing: '0em',
  lineHeight: 1.5,
};

/** Prefer solid color for chrome labels; gradient clip can ghost-edge glyphs on Windows. */
export const marketingGradientTextSx = (theme: Theme): SxProps<Theme> => ({
  color: theme.palette.primary.dark,
});
